// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l9-1";
export var messageSideRight = "_l9-2";
export var orderLookupBubbleContainer = "_l9-0";
export var submitButton = "_l9-3";